var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"inputmode":"numeric","label":"Cod. Segurança","placeholder":"xxx","hide-details":""}})}
var staticRenderFns = []

export { render, staticRenderFns }